<!-- 
    Uncomment below line to see the dashboard cache printed at the top of your screen.
    FOR DEBUGGING PURPOSES ONLY.
    Don't forget to re-comment.
    
    (orr.epstein)
-->
<!-- @if (dashboardState) {
    <pre style="background-color: white;">{{ dashboardState()?.cache | json }}</pre>
} -->

@if(useAuditTools){ @if(showAuditTools()){
<iq-builder-audit-tools
    [dashboardInfo]="dashboardState() ?? { id: '', sections: [] }"
    (closed)="toggleAuditTools()"
/>
}

<button
    class="fixed bottom-4 right-4 w-10 h-10 flex justify-center items-center text-white bg-dat-blue-500 z-10 rounded-full shadow-md hover:bg-dat-blue-600 active:bg-dat-blue-400"
    (click)="toggleAuditTools()"
>
    <span class="material-symbols-outlined iq-mat-icon-fill"> build </span>
</button>
} @if (loaded()) {

<iq-tracking-register />

<div
    [iqStyleProcessorClassname]="dashboardState()?.classNames"
    [class.opacity-0]="!loaded()"
    iqStyleProcessorStyleActions
    [cssClassRules]="dashboardState()?.cssClassRules"
    [attr.data-testId]="dashboardState()?.id"
    [attr.data-styleId]="dashboardState()?.id"
>
    @if (!hasSectionGroups()) { @for (section of dashboardState()?.sections;
    track section.id; let idx = $index) {
    <ng-container
        *ngTemplateOutlet="sectionTemplate; context: { $implicit: section }"
    />

    } } @else { @for (sectionGroupId of sectionGroups().keys(); track
    sectionGroupId; let idx = $index) {
    <div
        [attr.data-testId]="sectionGroupId"
        [attr.data-styletarget]="sectionGroupId"
    >
        @for (section of sectionGroups().get(sectionGroupId); track section.id)
        {

        <ng-container
            *ngTemplateOutlet="sectionTemplate; context: { $implicit: section }"
        />

        }
    </div>

    } }
</div>
}

<ng-template #sectionTemplate let-section>
    @switch (section.type) { @case('Draggable'){
    <ng-container
        *ngTemplateOutlet="
            draggableSectionTemplate;
            context: { $implicit: section }
        "
    />
    } @case ('Collapsible') {
    <ng-container
        *ngTemplateOutlet="
            collabsibleSectionTemplate;
            context: { $implicit: section }
        "
    />
    } @default {
    <ng-container
        *ngTemplateOutlet="
            defaultSectionTemplate;
            context: { $implicit: section }
        "
    />} }
</ng-template>

<ng-template #collabsibleSectionTemplate let-section>
    <section
        [iqStyleProcessorClassname]="section.classNames"
        [cssClassRules]="section.cssClassRules"
    >
        <mat-accordion [hideToggle]="true">
            <mat-expansion-panel
                class="!dat-border-card !shadow-none !rounded-sm"
                (opened)="sectionOpen(section)"
                (closed)="sectionClose(section)"
                [expanded]="!section.collapsed"
            >
                <mat-expansion-panel-header
                    class="!dat-accordion-header"
                >
                    @if(section.title?.length > 0) {
                    <header
                        [attr.data-styletarget]="section.id + '-header'"
                        [attr.data-uitype]="'section-header'"
                        class="!my-0 flex justify-between items-center w-full"
                    >
                        <iq-builder-label
                            [id]="id"
                            [label]="section?.title"
                            [type]="
                                section?.titleType?.length
                                    ? section?.titleType
                                    : 'md'
                            "
                            [tooltipBody]="section?.tooltipBody"
                            [flag]="section?.flag"
                            [flagLabel]="section?.flagLabel"
                            [tooltipHeader]="section?.tooltipHeader"
                            [htmlTooltip]="section?.tooltipLabel"
                        ></iq-builder-label>
                        <span class="material-symbols-outlined ali">
                            {{ section.collapsed ? 'add' : 'remove' }}
                        </span>
                    </header>
                    }
                </mat-expansion-panel-header>

                <iq-builder-section
                    [id]="section.id"
                    [dashboardId]="id"
                    [section]="section"
                ></iq-builder-section>
            </mat-expansion-panel>
        </mat-accordion>
    </section>
</ng-template>

<ng-template #draggableSectionTemplate let-section>
    <div
        cdkDrag
        [attr.data-styletarget]="section.id + '-draggable'"
        [attr.data-uitype]="'section-draggable'"
    >
        <iq-builder-section
            [iqStyleProcessorClassname]="section.classNames"
            [cssClassRules]="section.cssClassRules"
            [id]="section.id"
            [dashboardId]="id"
            [section]="section"
        ></iq-builder-section>
    </div>
</ng-template>

<ng-template #defaultSectionTemplate let-section>
    <section
        [iqStyleProcessorClassname]="section.classNames"
        [cssClassRules]="section.cssClassRules"
    >
        @if(section.title?.length > 0) {
        <header
            [attr.data-styletarget]="section.id + '-header'"
            [attr.data-uitype]="'section-header'"
            class="bg-white w-full border-solid border border-x-dat-grey-100 border-t-dat-grey-100 border-b-white py-4 px-4"
        >
            <iq-builder-label
                class="flex items-center"
                [id]="id"
                [label]="section?.title"
                [type]="section?.titleType ?? 'md'"
                [tooltipBody]="section?.tooltipBody"
                [flag]="section?.flag"
                [flagLabel]="section?.flagLabel"
                [tooltipHeader]="section?.tooltipHeader"
                [htmlTooltip]="section?.tooltipLabel"
            ></iq-builder-label>
        </header>
        }
        <iq-builder-section
            [id]="section.id"
            [dashboardId]="id"
            [section]="section"
        ></iq-builder-section>
    </section>
</ng-template>
